import { Route, Routes } from 'react-router-dom'

import Dashboard from './screens/Dashboard'
import Templates from './screens/Templates'

const AgencyMarketingRoutes = () => (
  <Routes>
    <Route path="/" element={<Dashboard />} />
    <Route path="/templates" element={<Templates />} />
  </Routes>
)

export default AgencyMarketingRoutes
